import 'reflect-metadata';
import Vue, { CreateElement } from 'vue';
// plugins
import container from '@/plugins/services';
import '@/plugins/env';
import { OrugaConfig } from '@/plugins/oruga';
// entry component
import StpDetail from './StpDetail.vue';

new Vue({
    provide: {
        ...container.getAll()
    },
    created() {
        // @ts-ignore
        this.$oruga.config.setOptions(OrugaConfig);
    },
    render(h: CreateElement) {
        return h(StpDetail);
    }
}).$mount('#albostpdetail');

